"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var StyledDivider = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n  margin: ", ";\n  background: ", ";\n  padding: 0 !important;\n  ", "\n"], ["\n  height: ", ";\n  width: ", ";\n  margin: ", ";\n  background: ", ";\n  padding: 0 !important;\n  ", "\n"])), function (_a) {
    var vertical = _a.vertical;
    return (vertical ? '100%' : '1px');
}, function (_a) {
    var vertical = _a.vertical;
    return (vertical ? '1px' : '100%');
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing, vertical = _a.vertical;
    return vertical ? "0 0 0 -" + theme.spacing[spacing] : theme.spacing[spacing] + " 0";
}, function (_a) {
    var theme = _a.theme, color = _a.color;
    return color || theme.colors.borderColor;
}, function (_a) {
    var vertical = _a.vertical;
    return vertical && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: absolute;\n      z-index: 2;\n      top: 0;\n      left: 50%;\n      padding: 0;\n      line-height: 0;\n      text-align: center;\n      -webkit-transform: translateX(-50%);\n      transform: translateX(-50%);\n      @media (max-width: 767px) {\n        width: 100%;\n        height: 1px;\n        left: 0;\n        top: 50%;\n        transform: translate(0, -50%);\n      }\n    "], ["\n      position: absolute;\n      z-index: 2;\n      top: 0;\n      left: 50%;\n      padding: 0;\n      line-height: 0;\n      text-align: center;\n      -webkit-transform: translateX(-50%);\n      transform: translateX(-50%);\n      @media (max-width: 767px) {\n        width: 100%;\n        height: 1px;\n        left: 0;\n        top: 50%;\n        transform: translate(0, -50%);\n      }\n    "])));
});
var Divider = function (_a) {
    var _b = _a.vertical, vertical = _b === void 0 ? false : _b, color = _a.color, _c = _a.spacing, spacing = _c === void 0 ? 'large' : _c;
    return react_1.default.createElement(StyledDivider, { spacing: spacing, color: color, vertical: vertical });
};
exports.default = Divider;
var templateObject_1, templateObject_2;
